import AppButton from "@/components/AppButton";
import DepositPendingList from "@/pages/assets/components/DepositPendingList";
import { getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {Box} from "@mui/material"
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";
import useSonicMigrateIntercept from "@/hook/useSonicMigrateIntercept";

function GuideDeposit() {
  const { t } = useTranslation();
  const pendingListRef = useRef();
  const { showAppStoreModal, setShowAppStoreModal, interceptAction } = useSonicMigrateIntercept();

  const { varieties } = useSelector(state => state.app);

  const _onDeposit = async () => {
    interceptAction();
  }

  const _onRefresh = async () => {
    dispatch(getUserInfo());
    pendingListRef.current?.loadData();
  }

  return (
    <Box className={'container-wrap'}>
      {t('deposit_first_for_purchase_card')}

      {t('support_crypto')}

      {varieties.map((variety) => <div>{variety.code}</div>)}

      <DepositPendingList ref={pendingListRef} />

      <AppButton onClick={_onDeposit}>{t('deposit')}</AppButton>

      <AppButton onClick={_onRefresh}>{t('refresh')}</AppButton>
      <OpenOrDownloadApp
        open={showAppStoreModal}
        onClose={() => setShowAppStoreModal(false)}
      />
    </Box>
  )
}

export default GuideDeposit
